import React, { useEffect, useState } from 'react';
import { AiTwotoneDelete } from 'react-icons/ai';
import { Link, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { client, urlFor } from '../client';
import { conDetailMoreConQuery, convoDetailQuery } from '../utils/data';
import Spinner from './Spinner';
import Comments from './Comments';

const ConversationDetail = ({ user }) => {
    const { conId } = useParams();
    const [pinDetail, setPinDetail] = useState();
    const [comment, setComment] = useState('');
    const [addingComment, setAddingComment] = useState(false);

    const fetchPinDetails = () => {
        const query = convoDetailQuery(conId);

        if (query) {
            client.fetch(`${query}`).then((data) => {
                setPinDetail(data[0]);
            });
        }
    };

    useEffect(() => {
        fetchPinDetails();
    }, [conId, comment]);

    const addComment = () => {
        const d = new Date();
        console.log(d);
        if (comment) {
            setAddingComment(true);

            client
                .patch(conId)
                .setIfMissing({ comments: [] })
                .insert('after', 'comments[-1]', [
                    { 
                        comment, 
                        _key: uuidv4(), 
                        postedBy: { 
                            _type: 'postedBy', 
                            _ref: user?._id 
                        }, 
                        commenter: { 
                            userName: user?.userName, 
                            image: user?.profUrl, 
                            _id: user?._id 
                        },
                        timeStamp: d,
                    }])
                .commit()
                .then(() => {
                    fetchPinDetails();
                    setComment('');
                    setAddingComment(false);
                });
        }
    };

    const deletePin = (id) => {
        client
            .delete(id)
            .then(() => {
                window.location.reload();
            });
    };

    if (!pinDetail) {
        return (
            <Spinner message="Showing pin" />
        );
    }

    return (
        <div className="m-2 p-1 bg-secondaryColor rounded-lg">
            <Link to={`/user-profile/${pinDetail?.postedBy?._id}`} className="flex gap-2 mt-5 items-center rounded-lg ">
                <img src={pinDetail?.postedBy.profUrl} className="w-10 h-10 rounded-full" alt="user-profile" />
                <p className="font-bold">{pinDetail?.postedBy.userName}</p>
            </Link>
            {
                pinDetail?.postedBy?._id === user?._id && (
                    <div className="flex gap-2 items-center">
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                console.log("deleted!")
                                deletePin(pinDetail._id);
                            }}
                            className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
                        >
                            <AiTwotoneDelete />
                        </a>
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                console.log("deleted!")
                                // deletePin(_id);
                            }}
                            className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
                        >
                            Edit
                        </a>
                    </div>
                )}
            {pinDetail && (
                <div className="flex xl:flex-row flex-col m-auto bg-white" style={{ maxWidth: '1500px', borderRadius: '32px' }}>

                    <div className="w-full p-5 flex-1 xl:min-w-620">

                        {/* <Link to={`/user-profile/${pinDetail?.postedBy._id}`} className="flex gap-2 mt-5 items-center bg-white rounded-lg ">
                            <img src={pinDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
                            <p className="font-bold">{pinDetail?.postedBy.userName}</p>
                        </Link> */}
                        <p className="font-bold">{pinDetail?.title}</p>
                        <div className='rounded-lg p-2 m-2 text-center'>
                            {pinDetail?.body}
                        </div>
                        <h2 className="mt-5 text-2xl">Comments</h2>
                        <div className="max-h-370 overflow-y-auto">
                            <Comments user={user} _detail={pinDetail} _id={conId} />
                        </div>
                        <div className="flex flex-wrap mt-6 gap-3">
                            <Link to={`/user-profile/${user?._id}`}>
                                <img src={user.profUrl} className="w-10 h-10 rounded-full cursor-pointer" alt="user-profile" />
                            </Link>
                            <textarea
                                className=" grow flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300 height-auto"
                                type="text"
                                placeholder="Add a comment"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />

                        </div>
                        <button
                            type="button"
                            className="flex justify-end items-center bg-indigo-500 text-white font-bold p-2 rounded-full w-auto m-1 outline-none"
                            onClick={addComment}
                        >
                            {addingComment ? 'Commenting...' : 'Comment'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConversationDetail;
